(function () {
    var tabela = document.querySelector('[data-zaleglosci-tabela]');
    if (!tabela || !tabela.tBodies.length) { return; }
    var tbody = tabela.tBodies[0];
    var wartosc = function (w, kol) {
        var v = w.cells[kol] ? w.cells[kol].getAttribute('data-sort') : null;
        return v === null || v === '' ? null : Number(v);
    };
    Array.prototype.forEach.call(tabela.querySelectorAll('th button[data-zaleglosci-sort]'), function (b) {
        b.addEventListener('click', function () {
            var th = b.parentNode, kol = Number(b.getAttribute('data-zaleglosci-sort'));
            var malejaco = th.getAttribute('aria-sort') !== 'descending';
            var wiersze = Array.prototype.slice.call(tbody.rows);
            wiersze.sort(function (a, c) {
                var x = wartosc(a, kol), y = wartosc(c, kol);
                // brak wartosci zawsze na koncu, remis rozstrzyga numer liczby rosnaco
                if (x === null && y === null) { return wartosc(a, 0) - wartosc(c, 0); }
                if (x === null) { return 1; }
                if (y === null) { return -1; }
                if (x === y) { return wartosc(a, 0) - wartosc(c, 0); }
                return malejaco ? y - x : x - y;
            });
            wiersze.forEach(function (w) { tbody.appendChild(w); });
            Array.prototype.forEach.call(tabela.querySelectorAll('th[aria-sort]'), function (t) { t.setAttribute('aria-sort', 'none'); });
            th.setAttribute('aria-sort', malejaco ? 'descending' : 'ascending');
        });
    });
})();
